package com.trevorwiebe.timesheet.mileage.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.MileageEntry
import com.trevorwiebe.timesheet.mileage.domain.model.TripType
import kotlinx.datetime.LocalDate

sealed class MileageEvent {
    data object OnShowAddDialog : MileageEvent()
    data object OnDismissAddDialog : MileageEvent()
    data class OnUpdateForm(val form: AddMileageFormState) : MileageEvent()
    data class OnSaveEntry(val entry: MileageEntry, val newLocation: Location?) : MileageEvent()
    data class OnSetOdometerError(val message: String?) : MileageEvent()
    data object OnConfirmOdometerWarning : MileageEvent()
    data object OnDismissOdometerWarning : MileageEvent()
    data class OnShowEditDialog(val entry: MileageEntry) : MileageEvent()
    data class OnUpdateEntry(val entry: MileageEntry, val newLocation: Location?) : MileageEvent()
    data class OnRequestDelete(val entry: MileageEntry) : MileageEvent()
    data object OnConfirmDelete : MileageEvent()
    data object OnDismissDelete : MileageEvent()
    data class OnFilterByEquipment(val equipmentId: String?) : MileageEvent()
    data class OnFilterByTripType(val types: Set<TripType>) : MileageEvent()
    data class OnFilterByEmployee(val employeeId: String?) : MileageEvent()
    data object OnStartDateClick : MileageEvent()
    data object OnEndDateClick : MileageEvent()
    data class OnStartDateSelected(val date: LocalDate) : MileageEvent()
    data class OnEndDateSelected(val date: LocalDate) : MileageEvent()
    data object OnDismissStartPicker : MileageEvent()
    data object OnDismissEndPicker : MileageEvent()
    data object OnClearFilters : MileageEvent()
    class OnReceiptImageSelected(val imageBytes: ByteArray) : MileageEvent()
    data object OnShowPhotoViewer : MileageEvent()
    data object OnDismissPhotoViewer : MileageEvent()
    class OnPhotoSaved(val rotatedBytes: ByteArray) : MileageEvent()
    data object OnPhotoDeleted : MileageEvent()
}
